enum EssentialOilsCategorySlugs {
  FR = 'huiles-essentielles',
  IT = 'oli-essenziali',
  DE = 'aetherische-oele',
  ES = 'aceites-esenciales',
  EN = 'essential-oils',
}

const hasEssentialOilsCategory = (categoriesSlugs: string[]): boolean => {
  return Array.isArray(categoriesSlugs)
    ? categoriesSlugs.some((slug: string) =>
        Object.values(EssentialOilsCategorySlugs).includes(slug as EssentialOilsCategorySlugs),
      )
    : false;
};

export default hasEssentialOilsCategory;
